import { UseQueryResult } from '@tanstack/react-query';
import React, { createContext, ReactNode, useContext } from 'react';

type FileListContextType = {
  filesQuery: UseQueryResult<any, unknown>;
};

const FileListContext = createContext<FileListContextType | undefined>(undefined);

type FileListProviderProps = {
  filesQuery: UseQueryResult<any, unknown>;
  children: ReactNode;
};

export const FileListProvider = ({ filesQuery, children }: FileListProviderProps) => {
  return <FileListContext.Provider value={{ filesQuery }}>{children}</FileListContext.Provider>;
};

export function useFileList() {
  const store = useContext(FileListContext);
  if (!store) {
    throw new Error('useFileList must be used within a FileListProvider');
  }
  return store;
}
